// Import the necessary types for better type safety
type AppConfig = {
  restBaseUrl: string;
  apiKey: string;
};

// Read Vite-provided environment variables at build time. Use direct
// `import.meta.env.VITE_*` references so Vite can statically replace them
// during build. Using an intermediate `env` variable prevents replacement
// and leaves `import.meta.env` in the final bundle.
let appConfig: AppConfig = {
  restBaseUrl: import.meta.env.VITE_REST_BASE_URL ?? "NO_VALUE",
  apiKey: import.meta.env.VITE_API_KEY ?? "NO_VALUE",
};

export function getAppConfig() {
  if (!appConfig.restBaseUrl || appConfig.restBaseUrl === "NO_VALUE") {
    throw new Error("Missing appConfig.restBaseUrl");
  }
  if (!appConfig.apiKey || appConfig.apiKey === "NO_VALUE") {
    throw new Error("Missing appConfig.apiKey");
  }
  return appConfig;
}

export function setAppConfig(newConfig: AppConfig) {
  appConfig = newConfig;
}
